import * as React from 'react';
import { SVGProps } from 'react';

export const ModelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.92725 1.99316H2.58269C2.25901 1.99316 1.99658 2.25559 1.99658 2.57931V4.96295C1.99658 5.28667 2.25897 5.5491 2.58273 5.5491C2.90645 5.5491 3.16888 5.28667 3.16888 4.96295V3.16546H4.92728C5.251 3.16546 5.51343 2.90303 5.51343 2.57931C5.51339 2.25559 5.25096 1.99316 4.92725 1.99316Z"
      fill="#071114"
    />
    <path
      d="M21.417 1.99316H19.0725C18.7488 1.99316 18.4863 2.25559 18.4863 2.57931C18.4863 2.90303 18.7487 3.16546 19.0725 3.16546H20.8309V4.96295C20.8309 5.28667 21.0933 5.5491 21.417 5.5491C21.7407 5.5491 22.0032 5.28667 22.0032 4.96295V2.57931C22.0032 2.25559 21.7407 1.99316 21.417 1.99316Z"
      fill="#071114"
    />
    <path
      d="M4.92728 20.8277H3.16888V19.0302C3.16888 18.7065 2.90645 18.4441 2.58273 18.4441C2.25901 18.4441 1.99658 18.7065 1.99658 19.0302V21.4139C1.99658 21.7376 2.25897 22 2.58273 22H4.92728C5.251 22 5.51343 21.7376 5.51343 21.4139C5.51343 21.0902 5.251 20.8277 4.92728 20.8277Z"
      fill="#071114"
    />
    <path
      d="M21.417 18.4441C21.0933 18.4441 20.8309 18.7065 20.8309 19.0302V20.8277H19.0725C18.7488 20.8277 18.4863 21.0902 18.4863 21.4139C18.4863 21.7376 18.7488 22 19.0725 22H21.417C21.7407 22 22.0032 21.7376 22.0032 21.4139V19.0302C22.0032 18.7065 21.7407 18.4441 21.417 18.4441Z"
      fill="#071114"
    />
    <path
      d="M18.7611 7.84445L12.2344 4.06314C12.0891 3.97895 11.9098 3.97895 11.7646 4.06314L5.23525 7.84442C5.09131 7.92783 5.00146 8.08311 5.00146 8.24961C5.00146 8.25055 5.00156 8.25148 5.00156 8.25239V15.75C5.00156 15.9181 5.0929 16.0754 5.24 16.1582L11.7646 19.9369C11.8349 19.9776 11.9185 20 11.9995 20C12.0841 20 12.1668 19.976 12.2345 19.9369L18.7564 16.1582C18.7575 16.1576 18.7586 16.1569 18.7596 16.1563C18.9108 16.0473 18.9923 15.9556 18.9946 15.7557C18.9946 15.7538 18.9947 15.7519 18.9947 15.7501V8.25245C18.9947 8.25151 18.9948 8.25058 18.9948 8.24967C18.9948 8.08301 18.9049 7.9277 18.7611 7.84445ZM11.5309 18.7183L6.41131 15.7521L10.3581 13.4887C10.5827 13.36 10.6603 13.0736 10.5315 12.8491C10.4028 12.6246 10.1164 12.547 9.8919 12.6757L5.93871 14.9411V9.05964L11.5309 12.2712V18.7183ZM11.9995 11.4595L6.41062 8.24826L11.9995 5.0102L17.5884 8.24826L11.9995 11.4595ZM18.0606 14.9411L14.1071 12.6757C13.8826 12.547 13.5962 12.6245 13.4675 12.8491C13.3387 13.0736 13.4163 13.3599 13.6408 13.4887L17.5877 15.7521L12.4681 18.7182V12.2712L18.0605 9.05964V14.9411H18.0606Z"
      fill="#071114"
    />
  </svg>
);
export default ModelIcon;
